export const default_menus = [
  {
    name: "发动机",
    icon: "engine_icon",
    type: 1,
  },
  {
    name: "机油滤清器",
    icon: "machine_oil_icon",
    type: 4,
  },
  {
    name: "变速箱",
    icon: "gearbox_icon",
    type: 2,
  },
  {
    name: "轮胎",
    icon: "tyre_icon",
    type: 3,
  },
  {
    name: "制动系统",
    icon: "braking_system_icon",
    type: 5,
  },
];
